import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions';
import * as Modules from 'components/modules';
import styles from './popup.css';

class Popup extends React.Component {
  state = {};
  render() {
    const { children, resetPopup } = this.props;
    return (
      <React.Fragment>
        <div
          role="button"
          tabIndex={0}
          onClick={resetPopup}
          className={styles.overlay}
        />
        <div className={styles.popup}>{children}</div>
      </React.Fragment>
    );
  }
}

const mapDispatch = dispatch => ({
  resetPopup: popup => dispatch(actions.resetPopup(popup)),
});

export default connect(null, mapDispatch)(Popup);



// WEBPACK FOOTER //
// ./src/components/modules/Popup/Popup.js